import React, { useState } from "react";
import { toast } from "react-toastify";

import ProgramContainer from "../../../profile/about-section/common/components/program/ProgramContainer";
import AddProgramSelector from "./AddProgramSelector";
import Accordion from "../../../../lib/components/Accordion/Accordion";

export default function AddNewProgram({
  setShowEducationModal,
  isAddNewVisible,
  setIsAddNewVisible,
}) {
  const [location, setLocation] = useState(null);
  const [programStage, setProgramStage] = useState(null);

  return (
    <Accordion
      heading={"Add Program"}
      onClickAction={() => {
        if (!isAddNewVisible) {
          setLocation(null);
          setProgramStage(null);
        }
        setIsAddNewVisible(!isAddNewVisible);
      }}
      body={
        <div>
          <div className="pb-4 pl-4 space-y-3">
            <AddProgramSelector
              heading={"Select Location"}
              values={["domestic", "international"]}
              checked={location}
              setChecked={setLocation}
            />
            <AddProgramSelector
              heading={"Select Stage"}
              values={["Enrolled", "Alumni"]}
              checked={programStage}
              setChecked={setProgramStage}
            />
          </div>
          {location && programStage && (
            <div className="pb-3 animate-slide-in">
              <ProgramContainer
                type={location}
                programStage={programStage}
                setShowEducationModal={setShowEducationModal}
                onSuccess={() => {
                  setIsAddNewVisible(true);
                }}
                onFailure={() => {
                  setIsAddNewVisible(true);
                }}
                hidePrograms={true}
              />
            </div>
          )}
        </div>
      }
    />
  );
}
